export abstract class HewSyncID<T = any> {
	constructor(public readonly value: T) {}

	public toJSON() {
		return this.value;
	}

	public toString(): string {
		return this.value as unknown as string; // TODO: Fix this
	}
}

export class AdminAccountID extends HewSyncID<string> {
	readonly type = "AdminAccount";
}
export class AdminContactID extends HewSyncID<string> {
	readonly type = "AdminContact";
}
export class AdminGroupID extends HewSyncID<string> {
	readonly type = "AdminGroup";
}
export class AdminRoleID extends HewSyncID<string> {
	readonly type = "AdminRole";
}
export class AdminOrganizationID extends HewSyncID<string> {
	readonly type = "AdminOrganization";
}

export class ProjectTemplateID extends HewSyncID<string> {
	readonly type = "ProjectTemplate";
}
export class ProjectVersionID extends HewSyncID<string> {
	readonly type = "ProjectVersion";
}
export class ProjectInstanceID extends HewSyncID<string> {
	readonly type = "ProjectInstance";
}

export class SynapseBrokerID extends HewSyncID<string> {
	readonly type = "SynapseBroker";
}
export class SynapseNodeID extends HewSyncID<string> {
	readonly type = "SynapseNode";
}

export class UserAccountID extends HewSyncID<string> {
	readonly type = "UserAccount";
}
export class UserGroupID extends HewSyncID<string> {
	readonly type = "UserGroup";
}
export class UserRoleID extends HewSyncID<string> {
	readonly type = "UserRole";
}
export class UserOrganizationID extends HewSyncID<string> {
	readonly type = "UserOrganization";
}
export class UserAssetID extends HewSyncID<string> {
	readonly type = "UserAsset";
}
export class UserEntityID extends HewSyncID<string> {
	readonly type = "UserEntity";
}
export class UserEntityTokenID extends HewSyncID<string> {
	readonly type = "UserEntityToken";
}
export class UserInviteID extends HewSyncID<string> {
	readonly type = "UserInvite";
}

export class SynapseBetaFileDescriptorID extends HewSyncID<string> {
	readonly type = "SynapseBetaFileDescriptor";
}
export class SynapseBetaPipelineDefinitionID extends HewSyncID<string> {
	readonly type = "SynapseBetaPipelineDefinition";
}
export class SynapseBetaPipelineTaskID extends HewSyncID<string> {
	readonly type = "SynapseBetaPipelineTask";
}
export class SynapseBetaPipelineID extends HewSyncID<string> {
	readonly type = "SynapseBetaPipeline";
}
export class SynapseBetaPlanID extends HewSyncID<string> {
	readonly type = "SynapseBetaPlan";
}
export class SynapseBetaReportID extends HewSyncID<string> {
	readonly type = "SynapseBetaReport";
}
export class SynapseBetaSessionID extends HewSyncID<string> {
	readonly type = "SynapseBetaSession";
}
export class SynapseBetaSessionMessageID extends HewSyncID<string> {
	readonly type = "SynapseBetaSessionMessage";
}

export class SynapseDataSourceID extends HewSyncID<string> {
	readonly type = "SynapseDataSource";
}

export class HewSyncPath extends HewSyncID<ReadonlyArray<string>> {
	readonly type = "HewSyncPath";

	public override toJSON() {
		return this.value;
	}

	public override toString() {
		return this.value.join("/");
	}
}
